module.exports = __webpack_public_path__ + "img/stand.97404a55.svg";